<div class="modal-header">
  <h4 class="modal-title">Split transaction</h4>
</div>
<div class="modal-body">
  <div class="form-label">Select a category for your split.</div>
  <app-select-transaction-category
    [selectedCategoryId]="selectedCategory"
    [errorMessage]="showCatError"
    [placeholder]="'Select or search a category'"
    [clearable]="false"
    [searchable]="true"
    [showHiddenCategories]="false"
    (categoryChange)="onCategoryChange($event)">
  </app-select-transaction-category>
  @if (showCatError) {
    <div class="invalid-feedback d-block">
      {{ showCatError }}
    </div>
  }
</div>

<div class="modal-footer">
  <button
    type="button"
    id="modalCancelBtn"
    class="btn btn-outline-dark"
    aria-label="Close"
    (click)="onCancel()">
    Cancel
  </button>
  <button
    id="modalAcceptBtn"
    class="btn btn-primary"
    type="button"
    (click)="onAccept()">
    Save
  </button>
</div>
